import React from 'react'
import OrderSuccess from '../../pages/OrdersAuth/OrderSuccess/OrderSuccess'
import { ORDER_SUCCESS as STRINGS } from "businesslogic/strings/ordersAuth";
import { useSelector } from 'react-redux';
import { getOrdersAuthData } from 'businesslogic/dataStore/reducers/ordersAuth';

const orderSuccessContainer = (WrappedComponent) => () => {
  const orderData = useSelector(getOrdersAuthData);
  return (
    <WrappedComponent
      title={STRINGS[orderData.order_type].title.text}
      subtitle={STRINGS[orderData.order_type].subtitle.text}
    />
  )
}

export default orderSuccessContainer(OrderSuccess)